import { useQuery } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

export const notificationKeys = {
  all: ['notifications'],
  list: (page, size) => [...notificationKeys.all, 'list', page, size],
  count: () => [...notificationKeys.all, 'count'],
  detail: (notificationId) => [...notificationKeys.all, 'detail', notificationId],
};

export const useNotifications = ({ page = 0, size = 10 } = {}) => {
  return useQuery({
    queryKey: notificationKeys.list(page, size),
    queryFn: async () => serverRequest('GET', `notifications?page=${page}&size=${size}`),
    select: (result) => result?.data ?? result,
    onError: (error) => notifyUser('error', error, 'Notifications'),
  });
};

export const useNotificationCount = () => {
  return useQuery({
    queryKey: notificationKeys.count(),
    queryFn: async () => serverRequest('GET', 'notifications/count'),
    select: (result) => {
      const value = result?.data ?? result?.count ?? result;
      if (typeof value === 'number') return value;
      return Number(value?.count ?? value?.total ?? value?.unreadCount ?? 0) || 0;
    },
    refetchInterval: 60000,
    staleTime: 30000,
    onError: (error) => notifyUser('error', error, 'Notification count'),
  });
};

export const useNotification = (notificationId) => {
  return useQuery({
    queryKey: notificationKeys.detail(notificationId),
    queryFn: async () => serverRequest('GET', `notifications/${encodeURIComponent(notificationId)}`),
    enabled: Boolean(notificationId),
    select: (result) => result?.data ?? result,
    onError: (error) => notifyUser('error', error, 'Notification'),
  });
};
